import React, { useContext, useId, useRef, useState } from "react";
import { ReviewIssueContext } from "./ReviewIssueHint";

export default function ReviewSection({ title, children }) {
  const [editing, setEditing] = useState(false);
  const section = useRef(null);
  const selection = useContext(ReviewIssueContext);
  const toggle = () => {
    if (
      selection &&
      section.current.contains(document.getElementById(selection.id))
    ) {
      selection.dismiss();
    }
    setEditing(!editing);
  };
  const readOnly = !editing;
  const id = useId();
  const action = readOnly ? "Odblokuj edycję" : "Zamknij edycję";
  return (
    <section
      ref={section}
      className="card premium-panel premium-review-section"
      aria-labelledby={id}
    >
      <div className="premium-review-header">
        <h2 id={id}>{title}</h2>
        <button
          type="button"
          className="premium-edit-toggle"
          aria-label={`${action} – ${title}`}
          title={action}
          aria-pressed={!readOnly}
          onClick={toggle}
        >
          <i
            className={readOnly ? "bi bi-pencil" : "bi bi-x-lg"}
            aria-hidden="true"
          />
        </button>
      </div>
      <ReviewIssueContext.Provider value={readOnly ? selection : null}>
        {children(readOnly)}
      </ReviewIssueContext.Provider>
    </section>
  );
}
